/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInner } from './LookupArtistsResponseArtistsInner';
import {
    LookupArtistsResponseArtistsInnerFromJSON,
    LookupArtistsResponseArtistsInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerToJSON,
} from './LookupArtistsResponseArtistsInner';

/**
 * 
 * @export
 * @interface CreateArtistAndLinkRequest
 */
export interface CreateArtistAndLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequest
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequest
     */
    source: CreateArtistAndLinkRequestSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequest
     */
    stageName: string;
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInner>}
     * @memberof CreateArtistAndLinkRequest
     */
    members?: Array<LookupArtistsResponseArtistsInner>;
    /**
     * 
     * @type {string}
     * @memberof CreateArtistAndLinkRequest
     */
    featuredStatus?: CreateArtistAndLinkRequestFeaturedStatusEnum;
}


/**
 * @export
 */
export const CreateArtistAndLinkRequestSourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer'
} as const;
export type CreateArtistAndLinkRequestSourceEnum = typeof CreateArtistAndLinkRequestSourceEnum[keyof typeof CreateArtistAndLinkRequestSourceEnum];

/**
 * @export
 */
export const CreateArtistAndLinkRequestFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa'
} as const;
export type CreateArtistAndLinkRequestFeaturedStatusEnum = typeof CreateArtistAndLinkRequestFeaturedStatusEnum[keyof typeof CreateArtistAndLinkRequestFeaturedStatusEnum];


/**
 * Check if a given object implements the CreateArtistAndLinkRequest interface.
 */
export function instanceOfCreateArtistAndLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "stageName" in value;

    return isInstance;
}

export function CreateArtistAndLinkRequestFromJSON(json: any): CreateArtistAndLinkRequest {
    return CreateArtistAndLinkRequestFromJSONTyped(json, false);
}

export function CreateArtistAndLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateArtistAndLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': json['source'],
        'stageName': json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupArtistsResponseArtistsInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
    };
}

export function CreateArtistAndLinkRequestToJSON(value?: CreateArtistAndLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupArtistsResponseArtistsInnerToJSON)),
        'featuredStatus': value.featuredStatus,
    };
}

